import type * as React from "react"

import { SidebarInset } from "@/components/ui/sidebar"

type AppContentProps = {
  variant?: "header" | "sidebar" | "mobile"
  sheetOpen?: boolean
} & React.ComponentProps<"main">

export function AppContent({
  variant = "header",
  sheetOpen = false,
  children,
  ...props
}: AppContentProps) {
  if (variant === "sidebar") {
    return <SidebarInset {...props}>{children}</SidebarInset>
  }

  if (variant === "mobile") {
    return (
      <main
        className={`relative flex-1 ${sheetOpen ? "overflow-hidden" : "overflow-y-auto"}`}
        style={{
          boxShadow: "var(--fig-content-inset-shadow)",
          paddingBottom: 76,
        }}
        {...props}
      >
        {children}
      </main>
    )
  }

  return (
    <main
      className="mx-auto flex h-full w-full max-w-7xl flex-1 flex-col gap-4 rounded-xl"
      {...props}
    >
      {children}
    </main>
  )
}
